// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-avatar[data-v-68206e2c]{border:2px solid #e3e3e3;transition:.2s}.v-avatar[data-v-68206e2c]:hover{cursor:pointer;border-color:#192a67;transition:.2s}", ""]);
// Exports
module.exports = exports;
